<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Private Skins
        <small>accept or decline skins</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="ui six stackable cards" id="skins-cards"  v-if="skins.images.length">
          <div :class="'col-sm-6 col-md-4 card col-lg-' + bigScreenSkins" :data-skin-id="item.id" v-for="item in skins.visible_images">
              <img class="card-img-top" :src="baseUrl2 + '/public/images/skins_pre/'+item.skin_name+'.png'">
              <div class="card-block">

                <div class="card-text">
                  <span v-if="role >= 33">{{ item.ip }}</span>
                </div>
              </div>
              <div class="card-footer">
                <h4 class="text-center card-title mt-3" >{{ decodeURI(item.nickname) }}
                  <a style="font-size:14px;" :href="'https://fb.com/' + item.facebook_id"> | {{ item.firstname}} {{ item.lastname}}</a>
                </h4>
                <div class="card-text">
                  {{ item.additional_info }}
                </div>

                <button @click="removeSkinDB(item.skin_name, item.id)" class="btn btn-danger btn-sm">Delete</button>
                <button @click="approveSkin(item.skin_name, item.id)" class="btn btn-success pull-right btn-sm">Approve</button>
              </div>
          </div>
        </div>



      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'privateWaiting',

    data: function () {
      return {
        baseUrl2: 'https://agar.rs',
        loading: true,
        rename: false,
        skins: new Form({
          images: [],
          visible_images: [],
          skin_name: ''
        }),
        skinSearch: '',
        isActiveSearch: false,
        scrollCalled: 0,
        isLoadingNew: false,
        role: 1,
        bigScreenSkins: 3

      }
    },
    methods: {
      getSkinsDB: function () {
        var self = this
        this.skins.post(baseUrl + 'Skins/getWaitingPrivateSkinList').then(function (result) {
          self.skins.images = result.list
          self.skins.visible_images = result.list
          self.$store.commit('SET_PRIVATE_SKINS', Number(result.list.length))
          self.loading = false
        }, function (reason) {
          // rejection
        })
      },
      // Admin functions
      removeSkinDB: function (item, id) {
        var self = this
        var data = {
//          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': item,
          'id': id
        }
        this.skins.post(baseUrl + 'Skins/declinePrivateSkin', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === item) {
                if (i >= 0) {
                  self.skins.visible_images.splice(i, 1)
                  self.$store.commit('SET_PRIVATE_SKINS', self.$store.state.waitPrivateSkins - 1)
                  return 0
                }
              }
            })
          } else {
            alert('Greska. Skin je vec obrisan')
          }
        }, function (reason) {
          // rejection
        })
      },
      approveSkin: function (item, id) {
        var self = this
        var data = {
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': item,
          'id': id,
          'by': localStorage.user_id
        }
        this.skins.post(baseUrl + 'Skins/acceptPrivateSkin', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === item) {
                if (i >= 0) {
                  self.skins.visible_images.splice(i, 1)
                  self.$store.commit('SET_PRIVATE_SKINS', self.$store.state.waitPrivateSkins - 1)
                  return 0
                }
              }
            })
          } else {
            alert('Skin sa tim imenom vec postoji. Promeni ime skina')
          }
        }, function (reason) {
          // rejection
        })
      }
    },
    updated () {

    },
    created: function () {
      if (screen.width > 1500) {
        this.bigScreenSkins = 2
      }
      this.getSkinsDB()
      this.role = this.$store.state.role
    }
  }
</script>

<style>
@media (min-width: 992px) {
  .card-text {
    min-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// Private-Waiting.vue?23e80ed4